<template>
  <iframe
    class="airtable-embed"
    src="https://airtable.com/embed/shrTLQ4aRy98s4Kjj?backgroundColor=red&layout=card&viewControls=off"
    frameborder="0"
    onmousewheel
    width="100%"
    height="533"
    style="background: transparent; border: 1px solid #ccc;"
  ></iframe>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
